import { render } from "./SkeletonCalendarList.vue?vue&type=template&id=5ad56a38"
import script from "./SkeletonCalendarList.vue?vue&type=script&lang=js"
export * from "./SkeletonCalendarList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__